import {faArchive, faUpRightFromSquare} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppLink from "components/common/AppLink";
import { AppRoutes } from "config/router";
import If from "../../../../common/If";

type WalletPropertyViewProps = {
    model: {
        name: string,
        personId?: number,
        balance?: number | string,
        id?: number | string,
        archived?: boolean | null
    },
    open?: boolean
}

const WalletPropertyView = (props: WalletPropertyViewProps) => {

    const renderBalance = () => {
        const balance = props.model.balance ?
            <span className="balance">
                ({props.model.balance})
            </span> : undefined;
        
        const open = props.open ?
            <AppLink title="button.open" className="px-4" to={AppRoutes.PERSON_WALLET_VIEW} params={{ id: props.model.id }}>
                <FontAwesomeIcon icon={faUpRightFromSquare} />
            </AppLink> : undefined;

        return <>
            {balance}
            {open}
        </>
    }

    return (
        <div>
            <If condition={props.model.archived}>
                <FontAwesomeIcon icon={faArchive} className="pr-2 text-neutral-500" />
            </If>
            <span>{props.model.name}</span> {renderBalance()}
        </div>
    );
};

export default WalletPropertyView;
